export { simularCompararPrecosMercado } from './compararPrecosMercado';
export { simularEtanolGasolina, LIMITE_ETANOL_PADRAO } from './etanolGasolina';
export { simularDelivery, DELIVERY_CENARIOS } from './delivery';
export { simularAvistaParcelado } from './avistaParcelado';
export { simularQuantoGuardar } from './quantoGuardar';
export { formatBRL, formatNumber, formatPercent } from './format';

/** Slugs antigos redirecionam para o simulador unificado */
export const SIMULADORES_REDIRECTS = {
    'varejo-atacado': 'comparar-precos',
    'preco-por-medida': 'comparar-precos',
};

/** Catálogo do hub */
export const SIMULADORES_CATALOG = [
    {
        grupo: 'Mercado',
        itens: [
            {
                slug: 'comparar-precos',
                titulo: 'Comparar preços no mercado',
                descricao: 'Varejo vs atacado, tamanhos ou marcas — veja qual sai mais barato de verdade.',
                icon: 'ShoppingCartOutlined',
            },
        ],
    },
    {
        grupo: 'Posto e transporte',
        itens: [
            {
                slug: 'etanol-gasolina',
                titulo: 'Etanol vs gasolina',
                descricao: 'No posto: qual combustível enche o tanque com menos dinheiro?',
                icon: 'CarOutlined',
            },
        ],
    },
    {
        grupo: 'Comer e assinaturas',
        itens: [
            {
                slug: 'delivery',
                titulo: 'Delivery: pedir, buscar ou cozinhar',
                descricao: 'Vale pedir, buscar no local ou cozinhar? Veja o custo real.',
                icon: 'CoffeeOutlined',
            },
        ],
    },
    {
        grupo: 'Pagar e parcelar',
        itens: [
            {
                slug: 'avista-parcelado',
                titulo: 'À vista vs parcelado',
                descricao: 'Desconto à vista ou parcelar e deixar o dinheiro rendendo?',
                icon: 'CreditCardOutlined',
            },
        ],
    },
    {
        grupo: 'Poupança',
        itens: [
            {
                slug: 'quanto-guardar',
                titulo: 'Quanto preciso guardar',
                descricao: 'Objetivo + prazo em meses → parcela mensal sugerida para juntar o valor.',
                icon: 'FundOutlined',
            },
        ],
    },
];

export function getSimuladorBySlug(slug) {
    const resolved = SIMULADORES_REDIRECTS[slug] || slug;
    for (const grupo of SIMULADORES_CATALOG) {
        const found = grupo.itens.find((i) => i.slug === resolved);
        if (found) return found;
    }
    return null;
}

export function resolveSimuladorSlug(slug) {
    return SIMULADORES_REDIRECTS[slug] || slug;
}
